export function calculateDialogStartPositionFromElement(element) {
    if (element) {
        const elementCenterOffset = element.getBoundingClientRect();
        return {
            top: elementCenterOffset.top,
            left: elementCenterOffset.left,
            width: element.clientWidth,
            height: element.clientHeight
        };
    }
    return undefined;
}
